import { all, takeLatest, call, put } from 'redux-saga/effects'

import apiEndPoints from 'consts/apiEndPoints'
import api from 'services/api'
import handleErrors from 'services/handleErrors'

import {
  getCarriersRequest,
  getCarriersFailure,
  getCarriersSuccess,
} from './reducer'

function* getCarriers() {
  try {
    const response = yield call(api.get, apiEndPoints.miscellaneous.carriers)

    yield put(getCarriersSuccess(response.data.carriers))
  } catch (error) {
    yield put(getCarriersFailure())
    handleErrors(error, 'Não foi possível buscar as transportadoras')
  }
}

export default all([takeLatest(getCarriersRequest.type, getCarriers)])
